// extracted by mini-css-extract-plugin
module.exports = {"root":"LegalPopup_root__A0svC","hidden":"LegalPopup_hidden__Aenbx","closeButton":"LegalPopup_closeButton__OM_6D"};